import { IListCellUi } from '../../list-cell/model';

/**
 * Get select checkbox cell
 *
 * @param cell - FE cell base metadata
 */
export function getSelectCell(cell: IListCellUi): IListCellUi {
  // @WARN it shouldn't be zero! Safari case
  cell.width = '0.1px';
  cell.horizontalAlign = 'center';
  cell.trackBy = '';
  return cell;
}
